import { render, staticRenderFns } from "./MerchantCampaign.vue?vue&type=template&id=1029d73a"
import script from "./MerchantCampaign.vue?vue&type=script&lang=js"
export * from "./MerchantCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports